import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-describedby"]

import {
    ref,
    toRefs,
    computed,
} from 'vue'
import { useFocus } from '@vueuse/core';
import { QInput } from 'quasar';

// Personal libs
import { $t } from 'src/i18n/utils';
import { checkUsername } from '@shared/lib/security.lib';
import {
    usernameRules,
    usernameExample
} from '@shared/lib/form.lib';

/**
 * HTMLElement refs
 */
interface QInputEmailProps {
    // Model
    modelValue?: string

    // Content
    label: string
    placeholder?: string
    ariaDescribedBy?: string
    showAriaDescription?: boolean

    // Style
    extraClass?: string;
    dense?: boolean

    // State
    disable?: boolean
    required?: boolean
   
    // Actions
    onEnterKey?: (...args: any[]) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QInputUsername',
  props: {
    modelValue: {},
    label: {},
    placeholder: { default: undefined },
    ariaDescribedBy: {},
    showAriaDescription: { type: Boolean, default: false },
    extraClass: {},
    dense: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    required: { type: Boolean, default: true },
    onEnterKey: { type: Function, default: undefined }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

// Vendor
const customQInputUsername = ref<QInput>();
const { focused: customQInputUsernameFocused } = useFocus(customQInputUsername);

/**
 * Properties
 */
const props = __props;
const {
    onEnterKey,
    required,
    label,
    placeholder,
    ariaDescribedBy,
    extraClass,
    disable,
    dense,
    modelValue
} = toRefs(props);

/**
 * Events
 */
const emit = __emit

/**
 * Computed properties
 */
// If required, add a star at the beginning of the label
const computedLabel = computed<string>(() => `${required.value ? '* ' : ''}${label.value}`)

/**
 * Methods
 */
function clearUsername() {
    customQInputUsername.value?.resetValidation();
    emit('update:modelValue', undefined)
    customQInputUsernameFocused.value = true;
}

function hasError() {
    return customQInputUsername.value?.hasError
}

function validate() {
    customQInputUsername.value?.validate()
}

function resetValidation() {
    customQInputUsername.value?.resetValidation()
}

/**
 * Exposed methods
 */
__expose({
    clearUsername,
    hasError,
    validate,
    resetValidation
})

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(ariaDescribedBy) == null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
                'q-mx-sm': true,
                'sr-only': _ctx.showAriaDescription === false
            }),
          "aria-describedby": _unref(ariaDescribedBy) ?? 'id_example_username'
        }, " Exemple de username : " + _toDisplayString(_unref(usernameExample)), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createVNode(_unref(QInput), {
      "model-value": _unref(modelValue),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (newValue) => emit('update:modelValue', newValue)),
      ref_key: "customQInputUsername",
      ref: customQInputUsername,
      outlined: "",
      dense: _unref(dense),
      placeholder: _unref(placeholder),
      "aria-required": _unref(required),
      "aria-describedby": _unref(ariaDescribedBy) ?? 'id_example_username',
      "aria-invalid": _unref(checkUsername)(_unref(modelValue) ?? '') ? 'false' : 'true',
      "aria-disable": _unref(disable),
      disable: _unref(disable),
      label: computedLabel.value,
      type: "text",
      autocomplete: "username",
      "bg-color": _ctx.$q.dark.isActive ? 'black' : 'white',
      "label-color": _ctx.$q.dark.isActive ? 'white' : 'black',
      class: _normalizeClass(['q-mb-sm', _unref(extraClass)]),
      "input-class": [
                _ctx.$q.dark.isActive ? 'text-white' : 'text-black',
                'set-outline',
            ],
      "hide-bottom-space": "",
      "lazy-rules": "",
      rules: _unref(usernameRules),
      enterkeyhint: "done",
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(onEnterKey) != null ? _unref(onEnterKey)() : undefined), ["enter"]))
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_q_icon, { name: "person" })
      ]),
      append: _withCtx(() => [
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          dense: "",
          icon: "cancel",
          class: "set-outline",
          color: "primary",
          disable: _unref(disable),
          title: _unref($t)('form.username.reset'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clearUsername()), ["stop"]))
        }, null, 8 /* PROPS */, ["disable", "title"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value", "dense", "placeholder", "aria-required", "aria-describedby", "aria-invalid", "aria-disable", "disable", "label", "bg-color", "label-color", "class", "input-class", "rules"])
  ]))
}
}

})